export const getCookie = (cookies: string, name: string) => {
  return cookies.split('; ').reduce((r, v) => {
     const parts = v.split('=');

     return parts[0] === name ? decodeURIComponent(parts[1]) : r;
   }, '');
};

export const setCookie = (name: string, value: string, days?: number, path = '/', domain: string = '.cian.ru') => {
  const expires = days ? new Date(Date.now() + days * 864e5).toUTCString() : 0;
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}; domain=${domain}`;
};

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; expires=${new Date(-1)}; path=/; domain=.cian.ru`;
};
